import { useEffect, useState } from 'react';
import clsx from 'clsx';
import DoneOutlinedIcon from '@material-ui/icons/DoneOutlined';
import CloseOutlinedIcon from '@material-ui/icons/CloseOutlined';
import TableCell from '@material-ui/core/TableCell';
import { useDeviceRegistry } from 'app/protocol/DeviceRegistryProvider';

function DeviceIsOnlineTableCell(props) {
	const [isOnline, setIsOnline] = useState(false);
	const { deviceRegistryInitialized, deviceList } = useDeviceRegistry();

	useEffect(() => {
		setIsOnline(deviceList.includes(props.item.externalId));
	}, [deviceList, props.item]);

	return (
		<TableCell className="p-4 md:p-16" scope="row">
			<div className={clsx('sm:ml-6 sm:mr-6 flex justify-end items-center', !deviceRegistryInitialized ? 'opacity-50' : 'opacity-100')}>
				{isOnline ? (
					<div className="flex justify-center items-center text-green-700">
						<DoneOutlinedIcon /> Online
					</div>
				) : (
					<div className="flex justify-center items-center text-red-700">
						<CloseOutlinedIcon /> Offline
					</div>
				)}
			</div>
		</TableCell>
	);
}

export default DeviceIsOnlineTableCell;
